import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {PassOnLogService} from '../../services/pass-on-log.service';

@Component({
    templateUrl: 'pass-on-log.component.html',
})
export class PassOnLogComponent implements OnInit, OnDestroy {

    constructor(public passOnLogService: PassOnLogService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.passOnLogService.getBuildings();

        this.urlService.onUrlChange.subscribe(() => {
            this.passOnLogService.tabId = this.urlService.queryParams['tab'];
            this.passOnLogService.getData();
        });
        this.urlService.setQueryParams('allPassOnLogs');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.passOnLogService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.passOnLogService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/pass-on-log.component.ts